import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { TextAreaField } from './elements';

const validationSchema = Yup.object().shape({
  settings: Yup.string().required(`Can't be blank`),
})

export default function OpenSearchImportSettingsForm({submitHandler, defaultValues}) {
  return (
    <div className='open-search-settings'>
      <Formik
        initialValues={defaultValues}
        validationSchema={validationSchema}
        onSubmit={values => submitHandler(values)}>
        {({values}) => {
          return (
            <Form>
              <div>
                <div className='nv-open-search-settings-form__field'>
                  <div className='form-section'>
                    <div className='row'>
                      <div className='col-12'>
                        <TextAreaField name='settings' label={null} rows={10}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-actions'>
                <button type='submit' className='btn btn-info btn-sm mt-3 mb-1'>Import settings</button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
